//首页根据栏目获取文章列表（分页）
export const URL_CHANNEL_LIST_BYIDS = '/api/interface/queryPagecmsArticleinfo';
//获取专题数据
export const URL_Channel_Type = '/api/channel/queryCmsChannelinfoListByChannelType';
//获取文章详情
export const URL_ARTICLE_INFO = '/api/interface/getArticleinfo?articleId=';
// 名称查看接口
export const URL_DATA_HISTORY = '/api/portal/dataHistoryCity/find';
// 街区查看接口
export const URL_MING_STREET_INTERFACE = '/api/portal/dataHistoryStreet/find';
// 明镇查看接口
export const URL_MINGZHEN_INTERFACE = '/api/portal/dataHistoryTown/find';
// 明村查看接口
export const URL_MINGCUN_INTERFACE = '/api/portal/dataHistoryVillage/find';
// 中国世界文化遗产名录接口
export const URL_CULTURAL_HERITAGE_LIST = '/api/portal/dataWorldHeritagess';
// 全国重点文物保护单位接口
export const URL_CULTURAL_RELICS_PROTECTION = '/api/portal/dataNcrpuSc/find';
// 行政审批接口
export const URL_EXAMINATION_AND_APPROVAL = '/api/workGuide/itemList';
// 办事指南接口
export const URL_BUSINESS_GUIDE = '/api/workGuide/find';
// 是否是在线办事指南接口
export const URL_ISSHOW_BUSINESS_GUIDE = '/api/workGuide/online';
// 获取根据事项id附件列表接口
export const URL_MATTER_ID = '/api/getFileListByBId'
// 回显图片接口
export const URL_ECHO_PICTURE = '/api/getPicture';
// 省份 批次  各种类型   等等接口
export const URL_COMPREHENSIVE_EXCUSE = '/api/portal/sysCodes/find';
// 博物馆名录接口
export const URL_MUSEUM_DIRECTORY = '/api/portal/dataCollectionss';
// 全国珍贵文物数据库接口
export const URL_PRECIOUS_CULTURAL_RELICS = '/api/portal/find/BasicsDataCollectioncr';
// 涉案文物鉴定评估机构名单接口
export const URL_EVALUATION_INSTITUTIONS = '/api/portal/dataInvolvedAppraisalss';
// 全国文物保护工程资格人员数据库接口
export const URL_PRCPERSOM_FIND = '/api/data/prcperson/find/lists';
// 全国文物保护工程考古资质数据库接口
export const URL_DATAKGFJ_ZZDWS = '/api/getDataKgfjzzdws';
// 全国文物保护工程考古资质获取省份数据接口
export const URL_PROVINCE_LIST = '/api/provinceList ';
// 全国文物保护工程资格人员数据库点击行获取的详情接口
export const URL_ONTHELINE_CLICK = '/api/data/prcperson/portal/one';
// 全国文物保护工程资格人员数据库点击单位获取的详情接口
export const URL_COMPANY_ID = '/api/portal/prcunit/one';
// 根据单位获取人员信息
export const URL_PRCUNITID_BY_PRC = "/api/data/prcperson/portal/by/prcunitId";
// 全国文物商店、文物拍卖企业名单接口
export const URL_DATACRAUCTION = "/api/portal/dataCrAuctionOrganizationss";
// 单位接口
export const URL_FIND_LIST = "/api/portal/find/list";
// 标准规范
export const URL_INDUSTRY_BZGF_FIND = "/api/industry/bzgf/find";
// 标准规范getlisit
export const URL_LAWS_FIND = "/api/laws/find";
// 全部监管每一条的详情
export const URL_FINDREGULATORY_ONE = "/api/findRegulatory/one";
// 本级监管每一条的详情
export const URL_SELECTALLBYREGULATORYLOCALID = "/api/selectAllByRegulatoryLocalId";
// 全部监管列表数据
export const URL_FINDJGSXCATALOG = "/api/findJgsxCataLog";
// 本级监管列表数据
export const URL_PORTAL_GETLOCALLIST = "/api/portal/getLocalList";
// 系统通知
export const URL_CRBNOTICEMAIN_FIND = "/api/crbNoticeMaintenances/find";
// 办件公示
export const URL_PORTAL_APPLYLIST = "/api/portal/applyList";
// 办件统计
export const URL_PORTAL_STATISTIC = "/api/portal/statistic";
// 办件结果公开
export const URL_PORTAL_RESULTS = "/api/portal/results";
// 监管信息公开
export const URL_PORTAL_SUPERVISIONS = "/api/portal/supervisions";
export const URL_PORTAL_FIND = "/api/portal/find";
export const URL_PORTAL_INDEX = "/api/portal/index";
// 国家文物进出境审核管理处名单数据接口
export const URL_SACREEE_FIND = "/api/sacreee/find";
// 上海市民间收藏文物鉴定咨询推荐单位名单数据接口
export const URL_NCRAI_SHN_FIND = "/api/ncrai/shn/find";
// 民间收藏文物鉴定试点单位名单数据接口
export const URL_NCRAI_FIND = "/api/ncraei/find";
// 法律法规库数据接口
export const URL_LAWS_FIND_ONE = "/api/laws/find/one";
// 浏览次数
export const URL_DESCRIPTION_FIND = "/api/description/find";
export const URL_PORTAL_SEQUENCE = "/api/portal/sequence";
// 行业监管 法律法规 上一篇
export const URL_LAWS_FIND_BEFORE = "/api/laws/find/before";
// 行业监管 法律法规 下一篇
export const URL_LAWS_FIND_NEXT = "/api/laws/find/next";
// 办事事项 资料下载
export const URL_FILE_DOWNLOAD = '/api/print/zip'

